


























































































































































































































































































































































































































import { Vue, Component } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import AccountModule from '@/store/modules/Account';
import GeneralModule from '@/store/modules/General';
import AuthModule from '@/store/modules/Auth';
import CreateAccountData from '@/data/CreateAccount';

@Component
export default class AddSubAccountView extends Vue {
  AccountInstance = getModule(AccountModule, this.$store);

  AuthInstance = getModule(AuthModule, this.$store);

  GeneralInstance = getModule(GeneralModule, this.$store);

  mainKey = 0;

  UserData = CreateAccountData.initialUserData();

  async onSubmit() {
    this.UserData.type = 'SEAMLESS';
    this.UserData.role = this.AuthInstance.user.role === 'COMPANY' ? 'SUBCOMPANY' : 'SUBAGENT';
    const { status: { code, message } } = await this.AccountInstance.CreateAccount(this.UserData);
    if (code === 0) {
      this.mainKey += 1;
    }
    this.GeneralInstance.ShowAlert({
      isAlert: true,
      alertMsg: message,
      alertColor: code === 0 ? 'success' : 'danger',
    });
    this.UserData = CreateAccountData.initialUserData();
  }
}
